import { render, staticRenderFns } from "./MiddleCUCampus.vue?vue&type=template&id=04f017c9&scoped=true&"
import script from "./MiddleCUCampus.vue?vue&type=script&lang=js&"
export * from "./MiddleCUCampus.vue?vue&type=script&lang=js&"
import style0 from "./MiddleCUCampus.vue?vue&type=style&index=0&id=04f017c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f017c9",
  null
  
)

export default component.exports